"use client";
import { Box, Stack, Text, Heading, Flex, Divider, Button } from "@chakra-ui/react";
import {
  useSectionHeadingVariant,
  useTextVariants,
} from "@/theme/components/useSectionHeading";
import Link from "next/link";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import { TEXT_VARIANTS } from "@/theme/components/text";
import { BUTTON_VARIANTS } from "@/theme/components/button";
import VideoPlayerWithOverlay from "./videoPlayer";

type Props = {
  LeftPanel: {
    title: string;
    button: {
      text: string;
      link: string;
      label: string;
    };
  };
  RightPanel: {
    list: {
      title: string;
      content: string;
    }[];
  };
};

const VideoFrame = (props: Props) => {
  const HeadingVariant = useSectionHeadingVariant();
  const TextVariant = useTextVariants();
  const { LeftPanel, RightPanel } = props;
  return (
    <Flex direction={{ base: "column", md: "row" }}>
      <Box
        backgroundColor={"primary.200"}
        flex={"0 0 60%"}
        py={{ base: 10, md: 20 }}
        px={{ base: 6, md: 20 }}
        borderRadius={"8px"}
      >
        <Stack spacing={10} width={{ base: "100%", md: "85%" }}>
          <Heading as="h2" variant={HeadingVariant} color="white">
            {LeftPanel.title}
          </Heading>
          <VideoPlayerWithOverlay />
          <Stack spacing={2}>
            <Text variant={TextVariant} color="white">
              {LeftPanel.button.text}
            </Text>
            <Button
              as={Link}
              variant={BUTTON_VARIANTS.SECONDARY}
              href={LeftPanel.button.link}
              width={"fit-content"}
            >
              {LeftPanel.button.label}
            </Button>
          </Stack>
        </Stack>
      </Box>
      <Box
        my={{ base: "-4vw", md: "2vw" }}
        mx={{ base: "5vw", md: "5vw" }}
        ml={{ md: "-10%" }}
        backgroundColor={"white"}
        flex={"0 0 50%"}
        borderRadius={"8px"}
        justifyContent={"space-around"}
        boxShadow={"xl"}
        p={{ base: 5, md: 10 }}
      >
        {RightPanel.list.map((item, index) => (
          <Box key={index}>
            <Box>
              <Heading variant={HEADING_VARIANTS.SUBTITLE3} as="span">
                {item.title}
              </Heading>{" "}
              :{" "}
              <Text variant={TEXT_VARIANTS.BODY2} as="span" color="text.100">
                {item.content}
              </Text>
            </Box>

            <Divider my={4} />
          </Box>
        ))}
      </Box>
    </Flex>
  );
};

export default VideoFrame;
